import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';

type StepStatus = 'completed' | 'pending' | 'warning' | 'exception';

export interface ProcessStatusStep {
  label: string;
  date?: string;
  status?: StepStatus;
  externalStatus: string[];
  icon: string;
}
@Component({
  selector: 'pds-process-status',
  templateUrl: './process-status.component.html',
  styleUrls: ['./process-status.component.scss'],
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProcessStatusComponent {
  currentStep = input.required<string>();
  currentStepStatus = input.required<StepStatus>();
  steps = input.required<ProcessStatusStep[]>();

  formattedSteps = computed(() => {
    return this.updateStepStatus(this.steps(), this.currentStep(), this.currentStepStatus());
  });

  private updateStepStatus(steps: ProcessStatusStep[], currentStep: string, currentStepStatus: StepStatus): ProcessStatusStep[] {
    let isBefore = true;

    const stepsFormatted = steps.map((step) => {
      if (isBefore) {
        step.status = 'completed';

        if (step.externalStatus.includes(currentStep)) {
          isBefore = false;
          step.status = currentStepStatus;
        }
      } else {
        step.status = 'pending';
      }

      return step;
    });

    return stepsFormatted;
  }
}
